import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { propMatch } from '@/helpers/custom-prop-types';
import { apiGetOneProfessionalUnit } from '../../../../actions/ProfessionalUnitActions';
import { wrapDispatch } from '../../../../helpers/action';
/**
 * unitのデータ取得を行うHoc
 * @param ChildSkeletonComponent
 * @returns {function(*): (function(*): *)|*}
 * @constructor
 */
const UnitHoc = (ChildSkeletonComponent) => (ChildComponent) => {
    const UnitHocInner = (props) => {
        const { match: { params: { id }, }, } = props;
        const [loading, changeLoading] = useState(true);
        const dispatch = useDispatch();
        const unit = useSelector((state) => state.professionalUnit[id]);
        const profile = useSelector((state) => state.profile);
        const unitRef = useRef();
        unitRef.current = unit;
        useEffect(() => {
            let unmount = false;
            if (!unitRef.current) {
                changeLoading(true);
                wrapDispatch(dispatch, apiGetOneProfessionalUnit(id, { id })).finally(() => {
                    if (!unmount) {
                        changeLoading(false);
                    }
                });
            }
            else {
                changeLoading(false);
            }
            return () => {
                unmount = true;
            };
        }, [id, dispatch, changeLoading, unitRef]);
        if (!loading && !unitRef.current) {
            return _jsx(CustomRedirect, { to: '/mypage' });
        }
        if (loading && !unit) {
            return _jsx(ChildSkeletonComponent, {});
        }
        return _jsx(ChildComponent, Object.assign({}, props, { profile: profile, unit: unit }));
    };
    UnitHocInner.propTypes = {
        match: propMatch(),
    };
    return UnitHocInner;
};
export default UnitHoc;
